import { createContext } from 'react'
import { getTimeframes } from '@/config/charts'
import type { ChartTimeframeProviderState } from '@/components/shared/analytics/chart-timeframe/types'

const initialState: ChartTimeframeProviderState = {
  timeframe: getTimeframes()[0],
  setTimeframe: () => null,
  isLive: false,
  isRefreshing: false,
  refresh: () => null,
}

export const ChartTimeframeProviderContext =
  createContext<ChartTimeframeProviderState>(initialState)
